export default __webpack_public_path__ + "static/media/redmic-bridge_logo_horizontal.01e83140.png";